import type { TestId } from '@repo/test-id';
import { ArrowsRotateSpinIcon, ExclamationCircleIcon } from '@repo/icons';
import { tr } from '@repo/locale';

interface Props {
  testId: TestId;
  isLoadingDelayed: boolean;
  hasTimedOut: boolean;
}

const STATUS_CLASS_NAME =
  'border-stroke-base shadow-card text-body absolute top-24 left-1/2 z-floating inline-flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-2 rounded-full border px-3 py-1.5 text-sm md:top-6 text-balance';

export default function MapLoadingBadge({ testId, isLoadingDelayed, hasTimedOut }: Props) {
  if (hasTimedOut) {
    return (
      <div
        className={`bg-danger-soft w-100 ${STATUS_CLASS_NAME}`}
        data-testid={testId.append('load-failed')}
        role="alert"
      >
        <ExclamationCircleIcon className="size-4 shrink-0" />
        <span>{tr('parking_search:map_load_failed')}</span>
      </div>
    );
  }

  if (isLoadingDelayed) {
    return (
      <div className={`bg-primary w-60 ${STATUS_CLASS_NAME}`} data-testid={testId.append('loading')} role="status">
        <ArrowsRotateSpinIcon className="size-4 shrink-0" />
        <span>{tr('parking_search:map_loading')}</span>
      </div>
    );
  }

  return null;
}
